<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <el-breadcrumb class="target" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/offline' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>线下课程报名</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="cont bs">
        <div class="top">
          <h3 class="title">课程介绍</h3>
          <p>{{title}}</p>
        </div>
        <div class="info">
          <h3 class="title">基本信息</h3>
          <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
              <el-radio class="fl" v-model="form.sex" label="1">男</el-radio>
              <el-radio class="fl" v-model="form.sex" label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="form.phone" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="card">
              <el-input v-model="form.card" clearable></el-input>
            </el-form-item>
            <el-form-item label="QQ/邮箱：" prop="email">
              <el-input v-model="form.email" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="tel">
              <el-input v-model="form.tel" clearable></el-input>
            </el-form-item>
            <el-form-item label="单位名称：" prop="company">
              <el-input v-model="form.company" clearable></el-input>
            </el-form-item>
            <el-form-item label="通讯地址：">
              <el-input v-model="form.adress" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('form')">确认报名</el-button>
              <p class="tips">报名成功，可在我的报名中查看报名记录！</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";

export default {
  name: "offlineApply",
  data() {
    // 验证手机号
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    // 验证邮箱
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      } else {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }
    };
    return {
      title: sessionStorage.getItem("courseName"),
      courseId: this.$route.query.courseId,
      form: {
        name: "",
        sex: "1",
        phone: "",
        card: "",
        email: "",
        tel: "",
        company: "",
        adress: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|x|X)$)/,
            message: "证件号码格式有误！",
            trigger: "blur"
          }
        ],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        email: [{ required: true, validator: checkEmail, trigger: "blur" }],
        tel: [{ required: true, message: "联系电话不能为空", trigger: "blur" }]
      }
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  mounted() {},
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .getOfflineApply({
              registerName: this.form.name,
              registerSex: this.form.sex,
              registerPhone: this.form.phone,
              registerIdcard: this.form.card,
              registerEmail: this.form.email,
              technicalTitle: this.form.tel,
              registerEnterprise: this.form.company,
              registerAddress: this.form.adress,
              courseId: this.courseId
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "报名成功！"
                });
                setTimeout(() => {
                  this.$router.push({
                    path: "/offline"
                  });
                }, 2000);
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__content {
  width: 50%;
}
/deep/.el-form-item__label {
  font-size: 16px;
}
/deep/.el-form-item__content {
  text-align: center;
}
.target {
  line-height: 60px;
}
.cont {
  border-radius: 6px;
  background: #ffffff;
  padding: 20px 100px;
  .top {
    padding-bottom: 20px;
  }
  .title {
    line-height: 24px;
    border-left: 3px solid #409eff;
    padding-left: 10px;
    margin: 20px 0;
    font-size: 20px;
    font-weight: normal;
    color: #2c3e50;
  }
  .tips {
    line-height: 40px;
  }
}
</style>
